import { CHARACTER_SEPARATOR_DEVICE_NAME } from '../components/CycleChartPreview/constants';

const getChannelNumByString = (channelStr: string): number => {
  const channelNum = channelStr.split(CHARACTER_SEPARATOR_DEVICE_NAME)[1];
  return Number(channelNum);
};

export default getChannelNumByString;
